import { createReducer, on } from '@ngrx/store';
import * as fromEventsActions from '../actions/calendar.actions';
import { CalendarEvent } from 'src/app/models/calendar.model';

export interface EventsState {
  data: CalendarEvent[];
  loaded: boolean;
  loading: boolean;
  error: string;
}

export const initialState: EventsState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: ''
};

export const eventsReducer = createReducer(
  initialState,
  on(fromEventsActions.LoadEventsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromEventsActions.LoadEventsSuccessAction, (state, { data }) => ({
    ...state,
    data,
    loaded: true,
    loading: false
  })),
  on(fromEventsActions.LoadEventsFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromEventsActions.AddEventAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromEventsActions.AddEventSuccessAction, (state, { calendarEvent }) => ({
    ...state,
    data: [...state.data, ...[calendarEvent]],
    loaded: true,
    loading: false
  })),
  on(fromEventsActions.AddEventFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromEventsActions.UpdateEventAction, (state) => ({
    ...state,
    loading: true
  })),
  on(
    fromEventsActions.UpdateEventSuccessAction,
    (state, { calendarEvent }) => ({
      ...state,
      data: [
        ...state.data.filter((event) => event.id !== calendarEvent.id),
        ...[calendarEvent]
      ],
      loaded: true,
      loading: false
    })
  ),
  on(fromEventsActions.UpdateEventFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromEventsActions.RemoveEventAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromEventsActions.RemoveEventSuccessAction, (state, { id }) => ({
    ...state,
    data: state.data.filter((event) => event.id !== id),
    loaded: true,
    loading: false
  })),
  on(fromEventsActions.RemoveEventFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  }))
);
